// hooks/use-fetch-all-profiles.js
import { useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllProfileByFilter,
  fetchProfile,
} from "view/profile/store/services";
import { getProfile } from "view/profile/store/selector";
import { actions } from "view/search-profile/store/slice";
import { getItem } from "utils/local-storage";
import { errorToaster } from "utils/alerts";
import { checkMandatoryFieldsEmpty } from "utils/profile-validation";

export const useFetchAllProfiles = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const profile = useSelector(getProfile);

  const fetchProfiles = useCallback(
    async (
      search,
      minAge,
      maxAge,
      rasi,
      sort,
      currentPage,
      profilesAvailability,
      nakshatra
    ) => {
      setLoading(true);
      setError(null);

      try {
        const token = getItem("the_main_app");
        let currentProfile = profile;

        if (!currentProfile?.isProfileFetched) {
          if (token) {
            const profileData = await fetchProfile(token, dispatch);
            if (
              profileData &&
              profileData.success &&
              profileData.values &&
              profileData.values[0]
            ) {
              currentProfile = {
                ...currentProfile,
                ...profileData.values[0],
                isProfileFetched: true,
              };
            }
          }
        }

        if (checkMandatoryFieldsEmpty(currentProfile)) {
          const errorMsg =
            "fill the mandatory field in profile-edit page to view the profile.";
          setError(errorMsg);
          setLoading(false);
          return;
        }

        const response = await fetchAllProfileByFilter(
          token,
          search,
          minAge,
          maxAge,
          rasi,
          sort,
          currentPage,
          profilesAvailability,
          nakshatra
        );

        dispatch(actions.setPageLimit(response.data.limit));
        dispatch(actions.setAllProfiles(response.data.values));
        dispatch(
          actions.setTotalPage(
            Math.ceil(response.data.total / response.data.limit)
          )
        );
        dispatch(actions.setCurrentPage(response.data.page));

        return response.data;
      } catch (err) {
        console.error("Error fetching profiles:", err);
        setError(err.message || "Failed to fetch profiles");
        errorToaster(err.message || "Failed to fetch profiles");
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [dispatch, profile]
  );

  return {
    fetchProfiles,
    loading,
    error,
  };
};
